export default __webpack_public_path__ + "static/built-to-scale-c1746534d0db8a57db2dd9ff108f838f.gif";